export const SECTION_LABELS = [["purpose", "Purpose"], ["scope", "Scope"], ["legal_basis", "Legal and regulatory basis"], ["definitions", "Definitions"],
  ["policy_statement", "Policy statement"], ["procedure", "Procedure"], ["roles", "Roles and responsibilities"], ["records", "Records"],
  ["training", "Training"], ["monitoring", "Monitoring and audit"], ["inspector_focus", "What inspectors will look for"],
  ["related_documents", "Related documents"], ["appendices", "Appendices"]];

const Block = ({ k, v }) => {
  if (!v) return null;
  if (typeof v === "string") return <p>{v}</p>;
  if (["purpose", "scope", "policy_statement"].includes(k)) return v.map((p, i) => <p key={i}>{p}</p>);
  if (k === "definitions") return <ul className="list-disc pl-5">{v.map((d, i) => <li key={i}><b>{d.term}:</b> {d.meaning}</li>)}</ul>;
  if (k === "procedure") return v.map((s, i) => <div key={i}><p className="font-medium mt-2">{i + 1}. {s.heading}</p><ol className="list-decimal pl-5">{(s.steps || []).map((st, j) => <li key={j}>{st}</li>)}</ol></div>);
  if (k === "roles") return v.map((r, i) => <div key={i}><p className="font-medium mt-2">{r.role}</p><ul className="list-disc pl-5">{(r.responsibilities || []).map((x, j) => <li key={j}>{x}</li>)}</ul></div>);
  if (k === "appendices") return v.map((a, i) => <div key={i}><p className="font-medium mt-2">Appendix {i + 1}: {a.title}</p><ul className="list-disc pl-5">{(a.items || []).map((x, j) => <li key={j}>{x}</li>)}</ul></div>);
  return <ul className="list-disc pl-5">{v.map((x, i) => <li key={i}>{String(x)}</li>)}</ul>;
};

export function PolicyContentView({ content, testId = "policy-content-view" }) {
  return (
    <div className="text-sm space-y-2 leading-relaxed" data-testid={testId}>
      {SECTION_LABELS.map(([k, label]) => content[k] ? <section key={k}><h3 className="font-display font-semibold text-base mt-4 mb-1">{label}</h3><Block k={k} v={content[k]} /></section> : null)}
    </div>
  );
}
